import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { CookieService } from '../../services/cookie.service';

import { ApiConstant } from './../../utils/api-constant/api-constant.service';
import { PlatformService } from './../../services/platform.services';
import { TNK_TOKEN } from '../../shared/constants/cookies-name.constant';
import { AuthTokenService } from '../../services/authToken.service';
export class ConfirmationFormService {
public dataStore: Observable<any>;
private update: BehaviorSubject<any>;
private store;
/**
 * @param {?} http
 * @param {?} api
 * @param {?} platformService
 * @param {?} cookieService
 * @param {?} authTokenService
 */
constructor(
private http: HttpClient,
private api: ApiConstant,
private platformService: PlatformService,
private cookieService: CookieService,
private authTokenService: AuthTokenService,
  ) {
    // main store
    this.store = {
      step: 0,
      profile: null,
      loanData: null,
      workData: null,
      bankData: null,
      modal: null,
      consts: {
        MODAL_SUCCESS: 'success',
        MODAL_ERROR: 'error',
        MODAL_FAILED: 'failed',
      },
    };

    // main function for dispatcher
    this.update = <BehaviorSubject<any>>new BehaviorSubject({});
    this.dataStore = this.update.asObservable();
    this.update.next(this.store);
  }
/**
 * @param {?} obj
 * @return {?}
 */
public setStore(obj: any) {
    const /** @type {?} */ data = ( /** @type {?} */((<any>Object))).assign(this.store, obj);
    this.update.next(data);
  }
/**
 * @return {?}
 */
public nextStep(): void {
    this.setStore({
      step: this.store.step + 1,
    });

    if (this.platformService.isBrowser) {
      ( /** @type {?} */((<any>window))).scrollTo(0, 0);
    }
  }
/**
 * @return {?}
 */
public prevStep(): void {
    this.setStore({
      step: this.store.step - 1,
    });

    if (this.platformService.isBrowser) {
      ( /** @type {?} */((<any>window))).scrollTo(0, 0);
    }
  }
/**
 * @return {?}
 */
public closeModal(): void {
    this.setStore({
      modal: null,
    });
  }
/**
 * @return {?}
 */
public closeSuccessModal(): void {
    this.setStore({
      modal: null,
    });

    if (this.platformService.isBrowser) {
      location.reload();
    }
  }
/**
 * @return {?}
 */
public sendForm(): void {
    const /** @type {?} */ token = this.cookieService.get(TNK_TOKEN);
    const /** @type {?} */ authToken = this.authTokenService.getAuthToken(token);

    const /** @type {?} */ headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Auth-Token': authToken,
      }),
    };

    const /** @type {?} */ req = {
      loanId: this.store.loanData.id,
      street: this.store.workData.value.street,
      compOrBuilding: this.store.workData.value.compOrBuilding,
      buildingNumber: this.store.workData.value.buildingNumber,
      buildingType: this.store.workData.value.buildingType,
      flatNumber: this.store.workData.value.flatNumber,
      village: this.store.workData.value.village,
      district: this.store.workData.value.district,
      rt: this.store.workData.value.rt,
      rw: this.store.workData.value.rw,
      province: this.store.workData.value.province,
      postalCode: this.store.workData.value.postalCode,
      city: this.store.workData.value.city,
      bankName: this.store.bankData.bankName,
      accountNumber: this.store.bankData.accountNumber,
      accountType: this.store.bankData.accountType,
      jobRole: this.store.workData.value.jobRole,
      officePhoneNumber: this.store.workData.value.officePhoneNumber,
    };

    this.http.post(`${this.api.apiURL}/loan/confirm`, req, headers).subscribe(
      res => {
        this.setStore({
          modal: this.store.consts.MODAL_SUCCESS,
        });
      },
      (err: HttpErrorResponse) => {
        if (err.status === 500) {
          this.setStore({
            modal: this.store.consts.MODAL_ERROR,
          });
        } else {
          this.setStore({
            modal: this.store.consts.MODAL_FAILED,
          });
        }
      },
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
{type: ApiConstant, },
{type: PlatformService, },
{type: CookieService, },
{type: AuthTokenService, },
];
}

function ConfirmationFormService_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationFormService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationFormService.ctorParameters;
/** @type {?} */
ConfirmationFormService.prototype.dataStore;
/** @type {?} */
ConfirmationFormService.prototype.update;
/** @type {?} */
ConfirmationFormService.prototype.store;
/** @type {?} */
ConfirmationFormService.prototype.http;
/** @type {?} */
ConfirmationFormService.prototype.api;
/** @type {?} */
ConfirmationFormService.prototype.platformService;
/** @type {?} */
ConfirmationFormService.prototype.cookieService;
/** @type {?} */
ConfirmationFormService.prototype.authTokenService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
